module.exports = __webpack_public_path__ + "summary.png?99385f8e8d687e0ca289e46dcd46a32b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summary.png
// module id = 1016
// module chunks = 2